/**
 * Angular imports.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * Service imports.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { GetService } from './../../dataservices/get.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
/**
 * Modal imports.
 */
import { CommunityListResponse } from '../../onboarding/interface/apiResponse.model';
import { Community, CommunityList, CommunityConfirmation, ConfirmationModalData, CarousalRoute, COMMUNITY_PAGE } from '../../onboarding/interface/global.model';
/**
 * Constant imports.
 */
import { ACTION_ON, ACTION_TYPE, BOOLEAN, BREADCRUMB_PATHS, CAROUSEL, COMMUNITY_LIST_TYPE, CTA_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME, PRODUCT_TYPE_NUMBER_MAPPING, SCREEN_NAME } from '../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
/**
 * Rxjs Imports
 */
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { DASHBOARD_ENTRY, DASHBOARD_EXIT, ENTRY, EXIT, LIST_ENTRY, LIST_EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
 * Show the Community Listing.
 */
@Component({
  selector: 'app-community-listing',
  templateUrl: './community-listing.component.html',
  styleUrls: ['./community-listing.component.scss']
})
export class CommunityListingComponent implements OnInit, OnDestroy {

  /**
   * Community listing.
   * public Community listing.
   * Community card Translations.
   * Community list Translation.
   * Show/Hide the filter for community list.
   * Store the communities filter data.
   * Window scroll flag for the infinite scroll.
   * Community list page breadcrumbs.
   * Community list type for the listing api.
   * @notifier$ notifier subject to end data stream
   */
  public communityList: CommunityList[] = [];
  public publicCommunityList: CommunityList[] = [];
  public communityCardTranslation = {
    key1: this.mls.languageText.community.key10,
    key2: this.mls.languageText.community.key3,
    key3: this.mls.languageText.community.key11,
    key4: this.mls.languageText.community.key27,
  };
  public communityListTranslation = {
    key1: this.mls.languageText.community.key9,
    key2: this.mls.languageText.community.key5,
    key3: this.mls.languageText.community.key6,
    key4: this.mls.languageText.community.key7,
    key5: this.mls.languageText.community.key8,
    key6: this.mls.languageText.community.key11,
    key7: this.mls.languageText.community.key51,
    key8: this.mls.languageText.community.key53,
    key9: this.mls.languageText.community.key70,
    key10: this.mls.languageText.community.key72,
    key11: this.mls.languageText.community.key86,
    key12: this.mls.languageText.community.key51
  };
  public publicTranslations = {
    key1: this.mls.languageText.community.key71,
    key2: this.mls.languageText.community.key10
  };
  public isFiltersVisible = false;
  public filterData = [];
  public scrollWindow = BOOLEAN;
  public communityListBreadcrumb = [
    { name: this.mls.languageText.community.key25, path: BREADCRUMB_PATHS.HOME },
    { name: this.mls.languageText.community.key1, path: '' }
  ];

  /**
   * Constant for Community list
   */
  public communityListType = COMMUNITY_LIST_TYPE;
  /**
   * Notifier subject to close data stream
   */
  private notifier$ = new Subject();
  /**
   * Holds current page name
   */
  public page: COMMUNITY_PAGE;

  /**
   * @offset  for the community list.
   * @pOffset for public community list
   * @filterKey Filter key for the community list.
   * @showPublicCommunityList flag to show public community list carousal
   * @showNoCommunity Show No Community Flag
   * @isListEnabled list view is enabled
   * @numbers holds Number constants
   */
  public offset: number = NUMBERS.ONE;
  public pOffset: number = NUMBERS.ONE;
  public filterKey = '';
  public showPublicCommunityList = true;
  public showNoCommunity = true;
  public isListEnabled = false;
  public numbers = NUMBERS;
  public publicCommunityFullList = false;
  public confirmationModal = false;
  public confirmationText: ConfirmationModalData =
    {
      headingText: '',
      cancelButtonText: '',
      allowButtonText: '',
      bodyText: ''
    };
  public confirmedCommunity: CommunityConfirmation;
  /**
   * For storing value of param
   */
  public queryParam: CarousalRoute;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * Flag for back button visibility
   */
  public showBackButton = true;
  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * From which screen card is geting called.
   */
  public callingFrom: string;
  /**
   * Analytics scrren for withdarw request.
   */
  public callScreen = '';


  public communityDashboardEntryTime: number;

  public communityListingEntryTime: number;
  /**
   * Necessary instances.
   */
  constructor(
    private route: ActivatedRoute,
    private getApiService: GetService,
    public mls: NewLanguageService,
    public fcs: FunCollectionService,
    public dss: DataStorageService,
    private analyticSdk: Analytics
  ) { }

  public canLoad = true;
  public pendingLoad = false;
  public busyGettingData = false;


  /**
   * Call the resolver.
   */
  ngOnInit(): void {

    setInterval( () => {
      this.canLoad = true;
      if ( this.pendingLoad ) {
        this.onScrollDown();
      }
    }, 2000);

    this.subscriptions.add(this.route.queryParams.subscribe((params: CarousalRoute)=> {
      if(params && params.view === CAROUSEL.VIEW_ALL){
        this.setFilter(COMMUNITY_LIST_TYPE.PUBLIC_COMMUNITY,false,true);
      }
      else if(params && params.view === CAROUSEL.MY_COMMUNITY_CAROUSEL){
        this.setFilter(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY,false,false);
      }
      else{
        this.getListFromResolver();
        this.confirmationText.bodyText = this.mls.languageText.community.key91;
        this.confirmationText.headingText = this.mls.languageText.community.key92;
        this.confirmationText.allowButtonText = this.mls.languageText.community.key93;
        this.confirmationText.cancelButtonText = this.mls.languageText.community.key94;
      }
    }));
    const d = new Date();
    this.sessiontime.start_time = d.getTime().toString();
  }

  public onScrollDown():void {
    
    if(this.busyGettingData){
      
      return;
    }
    this.busyGettingData = true;
    this.onScroll();
  }

  /**
   * Get community list from the resolver.
   */
  getListFromResolver(): void {
    this.callingFrom = SCREEN_NAME.COMMUNITY_DASHBOARD;
    this.communityDashboardEntryTime = new Date().getTime();
    const entryData: DASHBOARD_ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: 0,
      current_screen_name: SCREEN_NAME.COMMUNITY_DASHBOARD,
      start_time: this.communityDashboardEntryTime,
      source: this.fcs.currentScreename ?? localStorage.getItem('triggerSource')
    }
    this.analyticSdk.analyticService.DASHBOARD_ENTRY(entryData);
    this.fcs.currentScreename = SCREEN_NAME.COMMUNITY_DASHBOARD;
    this.route.data.subscribe(
      (data: { communityList: CommunityListResponse[] }) => {
        if (data && data.communityList) {
          if (data.communityList[0]) {
            this.communityList = data?.communityList[0].data?.community_list;
            for (let i = 0; i < this.communityList.length; i++) {
              if (this.communityList[i]['list'].length) {
                this.showNoCommunity = false;
              }
            }
            this.offset = data.communityList[0].data.offset;
          }
          if (data.communityList[1]) {
            this.publicCommunityList = data?.communityList[1].data.community_list;
            this.pOffset = data.communityList[1].data.offset;
            if(this.publicCommunityList[0].list.length < NUMBERS.TEN){
            this.publicCommunityList[0].list.push(null);
          }
          }
        }
      });
  }

  /**
   * get the community list acc to offset and key.
   */
  getCommunityList(key: string = COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY, offset: number, concat = false): void {
    // tslint:disable-next-line: no-unused-expression
    offset && this.getApiService.getCommunityList(key, offset.toString())
      .subscribe((res: CommunityListResponse) => {
        this.busyGettingData = false;
        if (key === COMMUNITY_LIST_TYPE.PUBLIC_COMMUNITY) {
          this.callingFrom = SCREEN_NAME.PUBLIC_COMMUNITIES_LIST;
        } else if (key === COMMUNITY_LIST_TYPE.MY_COMMUNITY) {
          this.callingFrom = SCREEN_NAME.MY_COMMUNITIES_LIST;
        } else if (key === COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY && !this.showPublicCommunityList) {
          this.callingFrom = SCREEN_NAME.MY_COMMUNITIES_LIST;
        }
        if (res.status === NUMBERS.ONE) {
          if(!concat && !this.publicCommunityFullList && COMMUNITY_LIST_TYPE.PUBLIC_COMMUNITY === key) {
            // No Code
          } else {
            if (!concat) {
              this.communityList = res.data.community_list;
              this.showNoCommunity = !(this.communityList && this.communityList[0].list.length > NUMBERS.ZERO);
            } else {
              this.communityList[0].list = this.communityList[0].list.concat(res.data.community_list[0].list);
            }
          }
          this.offset = res.data.offset;
        } else {
          this.fcs.errorHandeler(res);
        }
      }, (err) => {
        this.fcs.errorHandeler(err);
      });
  }

  /**
   * set Filter
   */
  setFilter(key: string, flag?: boolean, publicListView?: boolean): void {
    if (this.isListEnabled == true && this.filterKey) {
        const listExit: LIST_EXIT = {
          entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
          entity_code: 0,
          current_screen_name: key,
          start_time: this.communityListingEntryTime,
          end_time: new Date().getTime()
        }
        this.analyticSdk.analyticService.LIST_EXIT(listExit);
    } 
    this.filterKey = key;
    if (flag) {
      this.isListEnabled = false;
      this.showPublicCommunityList = true;
    } else {
      if (this.isListEnabled == false) {
        const exitData: DASHBOARD_EXIT = {
          entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
          entity_code: 0,
          current_screen_name: SCREEN_NAME.COMMUNITY_DASHBOARD,
          start_time: this.communityDashboardEntryTime,
          end_time: new Date().getTime()
        }
        this.analyticSdk.analyticService.DASHBOARD_EXIT(exitData);
      }
      this.isListEnabled = true;
      this.showPublicCommunityList = false;
      this.communityListingEntryTime = new Date().getTime();
      const listEntry: LIST_ENTRY = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
        entity_code: 0,
        current_screen_name: key,
        source: this.fcs.currentScreename ?? localStorage.getItem('triggerSource'),
        start_time: this.communityListingEntryTime
      }
      this.fcs.currentScreename = key;
      this.analyticSdk.analyticService.LIST_ENTRY(listEntry);
    }
    this.publicCommunityFullList = publicListView;
    this.getCommunityList(this.filterKey, 1);
    this.scrollToTop();
  }
  /**
   * set community Filter
   */
  setCommunityFilter($event: { key: string, flag?: boolean, publicListView?: boolean }): void {
    this.setFilter($event.key, $event.flag, $event.publicListView);
  }

  /**
   * Scroll to top when list gets empty/small.
   */
  scrollToTop(): void {
    window.scrollTo(0, 0);
  }

  /**
   * Get event when window scroll reach 80% of screen.
   */
  onScroll(): void {
    if (this.filterKey != '' && (this.offset > NUMBERS.TWO || this.isListEnabled)) {
      this.getCommunityList(this.filterKey, this.offset, true);
    }
  }
  /**
   * Emit Edit Community Id for Community Edit
  */
  emitCommunityEdit(event): void {
    this.fcs.navigateToCommunityEditPage(event?.id);
  }
  /**
   * Community Detail
   */
  emitCommunityDetail(community): void {
    this.fcs.navigateToCommunityDetailPage(community?.id);
  }
  /**
   * emit event for community detail page navigation
   * @param communityId
   */
  emitPublicCommunityDetail(communityId: string): void {
    this.fcs.navigateToCommunityDetailPage(communityId);
  }
  /**
   * Event handler for join public community
   * @param community
   */
  joinPublicCommunityHandler(community: Community): void {
    if (community && community.id) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,community?.da_id, SCREEN_NAME.COMMUNITY_DETAILS, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.JOIN_COMMUNITY, null);
      this.fcs.joinPublicCommunity(community.id).
        pipe(takeUntil(this.notifier$)).subscribe(
          (response) => {
            if (response.status === NUMBERS.ONE) {
              this.fcs.showSuccess(this.mls.languageText.toster.key2, this.mls.languageText.toster.key2);
              this.fcs.navigateToCommunityDetailPage(community?.id);
            } else {
              this.fcs.errorHandeler(response);
            }
          },
          error => {
            this.fcs.errorHandeler(error);
          }
        );
    }
  }

  /**
   * Confirmation withdraw request.
   */
  withdrawConfirmation(communityConfirmation: CommunityConfirmation): void {
    this.confirmedCommunity = communityConfirmation;
    this.confirmationModal = communityConfirmation.openModal;
    this.callScreen = communityConfirmation.callingFrom;
  }
  /**
   * Allow withdraw request.
   */
  allowAction(isAllow: boolean): void {
    if (isAllow) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.confirmedCommunity.community?.da_id, this.callingFrom, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK,ACTION_ON.WITHDRAW_REQUEST, null);
      this.resetConfirmModal();
    }
  }
  /**
   * Reset confirm modal.
   */
  resetConfirmModal(): void {
    this.confirmationModal = false;
  }

  /**
   * hide max memeber count message modal
   */
  onHidden(): void {
    this.fcs.publicCommunityMaxMemberCount$.next(false);
  }
  /**
   * Unsubscribe subsciptions
   */
  ngOnDestroy(): void {

    if (this.filterKey && this.isListEnabled == true) {
      const listExit: LIST_EXIT = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
        entity_code: 0,
        current_screen_name: this.filterKey,
        start_time: this.communityListingEntryTime,
        end_time: new Date().getTime()
      }
      this.analyticSdk.analyticService.LIST_EXIT(listExit);
    }
    else {
      const exitData: DASHBOARD_EXIT = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
        entity_code: 0,
        current_screen_name: SCREEN_NAME.COMMUNITY_DASHBOARD,
        start_time: this.communityDashboardEntryTime,
        end_time: new Date().getTime()
      }
      this.analyticSdk.analyticService.DASHBOARD_EXIT(exitData);
    }
    this.notifier$.next();
    this.notifier$.complete();
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  /**
   * Reload public community list
   */
  reloadPublicCommunityList(): void {
    this.publicCommunityFullList = false;
    this.getCommunityList(COMMUNITY_LIST_TYPE.PUBLIC_COMMUNITY, NUMBERS.ONE, false);
  }
  /**
   * Reload all community list
   */
  reloadAllCommunityList(): void {
    this.reloadPublicCommunityList();
    this.getCommunityList(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY, NUMBERS.ONE, false);
  }

  /**
   * Handler for back button event emit
   * @param event
   */
  onBackBtnEmit(event: boolean): void {
    this.showBackButton = event;
  }

  /**
   * Handler for back button click
   */
  backButtonHandler(): void {
    this.page = COMMUNITY_PAGE.COMMUNITY_LIST;
    this.setFilter(this.communityListType.PUBLIC_COMMUNITY, true, false);
    this.setFilter(this.communityListType.MY_ALL_COMMUNITY, true);
    this.communityDashboardEntryTime = new Date().getTime();
    const entryData: DASHBOARD_ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,
      entity_code: 0,
      current_screen_name: SCREEN_NAME.COMMUNITY_DASHBOARD,
      start_time: this.communityDashboardEntryTime,
      source: this.fcs.currentScreename ?? localStorage.getItem('triggerSource')
    }
    this.analyticSdk.analyticService.DASHBOARD_ENTRY(entryData);
    this.fcs.currentScreename = SCREEN_NAME.COMMUNITY_DASHBOARD;
  }

  /**
   * Handler to set page name
   * @param pageName
   */
  setPage(pageName: COMMUNITY_PAGE): void {
    this.page = pageName;
  }

  /**
   * view all clicked
   */
  viewAllClicked(event): void {
    const actionOn = 'VIEWALL_' + event;
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY, 0, this.callingFrom, CTA_TYPE.TEXT, ACTION_TYPE.CLICK, actionOn, null);
  }
  /**
   * Handler for View all CTA Click
   * @param event
   */
  viewAllHandler(event): void {
    if (event === COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY) {
      this.page = COMMUNITY_PAGE.MY_COMMUNITY_LIST;
    }
    this.setFilter(event);
  }
}
